import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12.07 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.03 16.05c-.2 0-.38-.1-.49-.26C4.45 14.23.99 9.07.99 6.8c0-2.67 2.26-4.85 5.04-4.85s5.04 2.17 5.04 4.85c0 2.27-3.46 7.43-4.52 8.96-.14.19-.32.29-.52.29zm0-13.5c-2.45 0-4.44 1.91-4.44 4.25 0 1.67 2.38 5.69 4.42 8.62 2.08-2.93 4.46-6.95 4.46-8.62 0-2.34-2-4.25-4.44-4.25z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.03 9.09c-1.26 0-2.29-1.03-2.29-2.29s1.03-2.29 2.29-2.29S8.32 5.54 8.32 6.8 7.29 9.09 6.03 9.09zm0-3.98c-.93 0-1.69.76-1.69 1.69s.76 1.69 1.69 1.69 1.69-.76 1.69-1.69-.76-1.69-1.69-1.69z"
    }, null, -1)
  ])))
}
export default { render };